module.exports = __webpack_public_path__ + "static/media/right-arrow.5e5b72cc.svg";